/* Grußkarten-Overlay (Roadmap 3.9) - Auswahl + Grußtext direkt aus der Warenkorb-Schublade,
 * ohne sie zu verlassen. Ersetzt den bisherigen Link auf die Kollektionsseite.
 *
 * Gate sitzt in Liquid (settings.mhsys_grusskarten_overlay), nicht hier: der Auslöser-Knopf
 * [data-mhsys-grusskarten-oeffnen] existiert nur, wenn der Schalter an ist
 * (snippets/mhsys-warenkorb.liquid). Findet dieses Skript den Knopf nicht, tut es nichts.
 *
 * Overlay-DOM wird einmal per JS gebaut (wie das .mhsys-popup-Muster in mhsys-produkt.js für
 * Größentabelle/Versandkosten), aber mit eigenen .mhsys-grk__*-Klassen: mhsys-produkt.css lädt
 * nur auf der Produktseite, die Schublade erscheint auf jeder Seite.
 *
 * Karten kommen erst beim ersten Öffnen per Section-Rendering-API
 * (/collections/grusskarten-mit-wunschtext?section_id=mhsys-grusskarten-liste), danach für die
 * Sitzung im Speicher gecacht - kein Zusatzgewicht bei jedem Warenkorb-Aufruf.
 */
(() => {
  'use strict';

  if (window.mhsysGrusskartenBereit) return;
  window.mhsysGrusskartenBereit = true;

  // Woertlich dieselbe Zeichenklasse wie produktoptionen_zeichen_erlaubt() in mhsystem
  // core/produktoptionen.inc.php bzw. assets/mhsys-produktoptionen.js - eigene Kopie, weil jene
  // Datei nur auf der Produktseite laedt, die Schublade aber ueberall erscheint. ACHTUNG (live
  // gefunden 21.09.2026): \p{Latin} ist nur AUSSERHALB einer Zeichenklasse gueltig, innerhalb
  // von [...] verlangt Chrome die volle Form \p{Script=Latin}, sonst SyntaxError beim Parsen der
  // ganzen Datei.
  const ZEICHEN_ERLAUBT = /^[\p{Script=Latin}0-9\s.,\-'’!?&+/():;"„“@#€%]*$/u;
  const ZEICHEN_VERBOTEN = /[^\p{Script=Latin}0-9\s.,\-'’!?&+/():;"„“@#€%]/gu;

  function zeichenVerboten(text) {
    if (ZEICHEN_ERLAUBT.test(text)) return '';
    const treffer = text.match(ZEICHEN_VERBOTEN) || [];
    return [...new Set(treffer)].slice(0, 5).join('');
  }

  const routen = () => window.mhsysShop || {};

  let panel = null;
  let liste = null;
  let textBereich = null;
  let ausloeser = null;
  let geladen = false;
  let gewaehlteKarte = null;

  /* Zurueck-Taste schliesst das Overlay, die Schublade bleibt offen (Wunsch des Inhabers, 21.09.2026) -
     dasselbe Muster wie Schnellansicht (mhsys-schnellansicht.js) und Vollbild-Popup (mhsys-popup.js):
     beim Oeffnen ein eigener Verlaufseintrag {..., mhsysGrusskarte: true}, der bestehende Zustand wird
     weitergereicht, nie ersetzt. Den Eintrag darunter markiert mhsysOverlayBasis - daran erkennt der
     Geschenkefinder, dass er bei diesem Zurueck nicht auf Frage 4 springen soll; nach dem Schliessen kommt
     die Markierung wieder weg. Escape, X, Klick daneben und "Karte einlegen" gehen ueber history.back(),
     wenn der eigene Eintrag oben liegt - so bleibt kein verwaister Eintrag stehen. */
  function verstecken() {
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    document.documentElement.classList.remove('mhsys-overlay-offen');
    if (ausloeser && document.contains(ausloeser)) ausloeser.focus();
  }

  function schliessen() {
    if (!panel || panel.hidden) return;
    if (window.history.state && window.history.state.mhsysGrusskarte) {
      window.history.back();
    } else {
      verstecken();
    }
  }

  window.addEventListener('popstate', (e) => {
    if (e.state && e.state.mhsysOverlayBasis && !e.state.mhsysGrusskarte) {
      const ohne = Object.assign({}, e.state);
      delete ohne.mhsysOverlayBasis;
      try { window.history.replaceState(ohne, ''); } catch (err) {}
    }
    if (e.state && e.state.mhsysGrusskarte) return;
    verstecken();
  });

  function kartenZuruecksetzen() {
    gewaehlteKarte = null;
    if (liste) {
      liste.querySelectorAll('.mhsys-grk__karte').forEach((k) => {
        k.classList.remove('ist-gewaehlt');
        k.setAttribute('aria-pressed', 'false');
      });
    }
    if (textBereich) {
      textBereich.hidden = true;
      const feld = textBereich.querySelector('textarea');
      if (feld) feld.value = '';
      zeichenPruefenUndZaehlen();
    }
  }

  function zeichenPruefenUndZaehlen() {
    const feld = textBereich.querySelector('textarea');
    const fehler = textBereich.querySelector('.mhsys-grk__fehler');
    const zaehler = textBereich.querySelector('.mhsys-grk__zaehler');
    const max = parseInt(feld.dataset.max, 10) || 120;
    if (zaehler) zaehler.textContent = `${feld.value.length} / ${max}`;
    const verboten = zeichenVerboten(feld.value);
    if (verboten) {
      fehler.textContent = `Diese Zeichen gehen leider nicht: ${verboten}`;
      fehler.hidden = false;
      return false;
    }
    fehler.textContent = '';
    fehler.hidden = true;
    return true;
  }

  function karteWaehlen(karte) {
    if (gewaehlteKarte) {
      gewaehlteKarte.classList.remove('ist-gewaehlt');
      gewaehlteKarte.setAttribute('aria-pressed', 'false');
    }
    gewaehlteKarte = karte;
    karte.classList.add('ist-gewaehlt');
    karte.setAttribute('aria-pressed', 'true');

    const feld = textBereich.querySelector('textarea');
    feld.maxLength = parseInt(karte.dataset.max, 10) || 120;
    feld.dataset.max = karte.dataset.max || '120';
    const knopf = textBereich.querySelector('.mhsys-grk__knopf');
    const preis = parseInt(karte.dataset.preis, 10) || 0;
    // Zwei Fassungen, CSS zeigt je nach Breite nur eine (Fund des Inhabers: der volle Text
    // brach am Handy um) - geld() liefert eine reine Zahl+Komma+€-Zeichenkette, unbedenklich
    // fuer innerHTML.
    knopf.innerHTML = `<span class="mhsys-grk__knopf-kurz">Ins Eikaffskerberl</span><span class="mhsys-grk__knopf-lang">Karte ins Eikaffskerberl legen</span> · ${geld(preis)}`;
    textBereich.hidden = false;
    zeichenPruefenUndZaehlen();
    feld.focus();
  }

  function geld(cent) {
    // Einfache DE-Formatierung, wie money_format es in den allermeisten Faellen ausgibt -
    // reicht fuer diesen einen Anzeigezweck, keine vollstaendige Nachbildung noetig (die Karten
    // haben alle einen einfachen Cent-Betrag ohne Tausenderstellen).
    return (cent / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function kartenLaden() {
    if (geladen) return;
    geladen = true;
    /* Brezn als Ladeanzeige (Roadmap 4.14, assets/mhsys-popup.js) ueber beide Spalten der Kartenliste */
    if (typeof window.mhsysLadeAnzeige === 'function') {
      const li = document.createElement('li');
      li.className = 'mhsys-grk__laden';
      li.append(window.mhsysLadeAnzeige());
      liste.replaceChildren(li);
    } else {
      liste.innerHTML = '<p class="mhsys-grk__leer">Wird geladen …</p>';
    }
    fetch(`${(routen().grusskartenUrl || '/collections/grusskarten-mit-wunschtext')}?section_id=mhsys-grusskarten-liste`)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const quelle = doc.querySelector('[data-mhsys-grk-liste]');
        if (!quelle || !quelle.children.length) {
          liste.innerHTML = '<p class="mhsys-grk__leer">Gerade keine Grußkarten verfügbar.</p>';
          return;
        }
        liste.replaceChildren(...Array.from(quelle.children).map((n) => document.importNode(n, true)));
        liste.querySelectorAll('.mhsys-grk__karte').forEach((karte) => {
          karte.addEventListener('click', () => karteWaehlen(karte));
          karte.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              karteWaehlen(karte);
            }
          });
        });
      })
      .catch(() => {
        geladen = false; // beim naechsten Oeffnen erneut versuchen
        liste.innerHTML = '<p class="mhsys-grk__leer">Die Karten lassen sich gerade nicht laden. Bitte nochmal versuchen.</p>';
      });
  }

  function bauen() {
    panel = document.createElement('div');
    panel.className = 'mhsys-grk';
    panel.hidden = true;
    panel.innerHTML = `
      <div class="mhsys-grk__schleier" data-zu></div>
      <div class="mhsys-grk__panel" role="dialog" aria-modal="true" aria-label="Grußkarte beilegen" tabindex="-1">
        <div class="mhsys-grk__kopf mhsys-ueberlage__kopfzeile">
          <h2 class="mhsys-grk__titel mhsys-ueberlage__kopf">Grußkarte beilegen</h2>
          <button type="button" class="mhsys-grk__zu mhsys-ueberlage__zu" data-zu aria-label="Schließen"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M5.05 3.9c.3 0 .6.12.83.35L12 10.37l6.12-6.12a1.17 1.17 0 0 1 1.66 1.66L13.66 12l6.12 6.12a1.17 1.17 0 0 1-1.66 1.66L12 13.66l-6.12 6.12a1.17 1.17 0 0 1-1.66-1.66L10.34 12 4.22 5.88A1.17 1.17 0 0 1 5.05 3.9Z"/></svg></button>
        </div>
        <p class="mhsys-grk__hinweis">Wähl a Karterl aus und schreib dei Grußwort dazua - mia legn's deiner Bestellung bei.</p>
        <ul class="mhsys-grk__liste" data-mhsys-grk-liste></ul>
        <div class="mhsys-grk__text" hidden>
          <label for="mhsys-grk-text">Dein Grußtext (freiwillig)</label>
          <textarea id="mhsys-grk-text" rows="3"></textarea>
          <p class="mhsys-grk__zaehler">0 / 120</p>
          <p class="mhsys-grk__fehler" role="alert" hidden></p>
          <button type="button" class="mhsys-knopf mhsys-grk__knopf"><span class="mhsys-grk__knopf-kurz">Ins Eikaffskerberl</span><span class="mhsys-grk__knopf-lang">Karte ins Eikaffskerberl legen</span></button>
        </div>
      </div>
    `;
    document.body.appendChild(panel);

    liste = panel.querySelector('[data-mhsys-grk-liste]');
    textBereich = panel.querySelector('.mhsys-grk__text');

    panel.addEventListener('click', (e) => {
      if (e.target.closest('[data-zu]') || !e.target.closest('.mhsys-grk__panel')) schliessen();
    });
    textBereich.querySelector('textarea').addEventListener('input', zeichenPruefenUndZaehlen);
    textBereich.querySelector('.mhsys-grk__knopf').addEventListener('click', absenden);
  }

  function absenden() {
    if (!gewaehlteKarte) return;
    if (!zeichenPruefenUndZaehlen()) return;

    const knopf = textBereich.querySelector('.mhsys-grk__knopf');
    if (knopf.disabled) return;
    knopf.disabled = true;
    const textVorher = knopf.textContent;
    knopf.textContent = 'Einen Moment …';

    const wk = document.querySelector('mhsys-warenkorb');
    // trim(): drei Leerzeichen sind auch leer. Ein leeres freiwilliges Feld wird GAR NICHT
    // mitgeschickt (23.09.2026) - vorher ging "Grußtext" immer mit, bei leerem Feld als
    // {"key":"Grußtext","value":""}. Shopify behaelt so eine Eigenschaft in der Bestellung,
    // und in mhsys lag die Karte damit dem Versand zum Bedrucken vor, obwohl nichts drinstand
    // (Bestellung 39924). Karten ohne Text sind der Normalfall - 66 Kartenpositionen in vier
    // Wochen, davon 10 mit Text -, deshalb gehoert der leere Fall gar nicht erst in die Daten.
    const text = textBereich.querySelector('textarea').value.trim();
    const posten = {
      id: parseInt(gewaehlteKarte.dataset.varianteId, 10),
      quantity: 1,
    };
    if (text !== '') {
      // Lesbarer Schluessel (Roadmap 1.32) - der Kunde sieht ihn an der Kasse und in der Bestellbestaetigung.
      // mhsys liest "Grußtext" und das fruehere "grusstext" (produktoptionen_grusstext_wert()).
      posten.properties = { 'Grußtext': text };
    }
    const koerper = { items: [posten] };
    if (wk && wk.sectionName) {
      koerper.sections = wk.sectionName;
      koerper.sections_url = window.location.pathname;
      wk.ausloeserMerken(ausloeser);
    }

    fetch(`${(routen().warenkorbHinzufuegenUrl || '/cart/add')}.js`.replace(/\.js\.js$/, '.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-Mhsys-Warenkorb': '1',
      },
      body: JSON.stringify(koerper),
    })
      .then((r) => r.json())
      .then((antwort) => {
        if (antwort.status) {
          const fehler = textBereich.querySelector('.mhsys-grk__fehler');
          fehler.textContent = antwort.description || antwort.message || 'Das hat leider nicht geklappt.';
          fehler.hidden = false;
          if (wk) wk.nurNeuLaden();
          return;
        }
        if (wk) wk.antwortEinsetzen(antwort);
        document.dispatchEvent(new CustomEvent('mhsys:warenkorb-geaendert', { detail: { quelle: 'grusskarten' } }));
        schliessen();
        kartenZuruecksetzen();
      })
      .catch(() => {
        const fehler = textBereich.querySelector('.mhsys-grk__fehler');
        fehler.textContent = 'Das hat leider nicht geklappt. Bitte nochmal versuchen.';
        fehler.hidden = false;
      })
      .finally(() => {
        knopf.disabled = false;
        knopf.textContent = textVorher;
      });
  }

  function oeffnen(knopf) {
    if (!panel) bauen();
    ausloeser = knopf;
    if (!panel.hidden) return;
    try {
      const basis = Object.assign({}, window.history.state || {}, { mhsysOverlayBasis: true });
      window.history.replaceState(basis, '');
      const eigen = Object.assign({}, window.history.state || {}, { mhsysGrusskarte: true });
      delete eigen.mhsysOverlayBasis;
      window.history.pushState(eigen, '');
    } catch (e) {}
    panel.hidden = false;
    document.documentElement.classList.add('mhsys-overlay-offen');
    panel.querySelector('.mhsys-grk__panel').focus();
    kartenLaden();
  }

  document.addEventListener('click', (e) => {
    const knopf = e.target.closest('[data-mhsys-grusskarten-oeffnen]');
    if (knopf) oeffnen(knopf);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') schliessen();
    // Fokusfalle: aria-modal allein haelt die Tab-Taste nicht im Panel (dasselbe Muster wie das
    // Groessentabelle-Popup in mhsys-produkt.js)
    if (e.key !== 'Tab' || !panel || panel.hidden) return;
    const kasten = panel.querySelector('.mhsys-grk__panel');
    const ziele = [...kasten.querySelectorAll('a[href], button:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])')]
      .filter((el) => el.offsetParent !== null);
    if (!ziele.length) return;
    const erstes = ziele[0];
    const letztes = ziele[ziele.length - 1];
    const drin = kasten.contains(document.activeElement) && document.activeElement !== kasten;
    if (e.shiftKey && (!drin || document.activeElement === erstes)) {
      e.preventDefault();
      letztes.focus();
    } else if (!e.shiftKey && (!drin || document.activeElement === letztes)) {
      e.preventDefault();
      erstes.focus();
    }
  });
})();
